<template>
  <a-card v-if="pageLoading">
    <a-spin
      tip="Your document is being processed, do not leave this page!"
      :spinning="pageLoading"
    />
  </a-card>
  <a-form :form="form" v-else>
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
        <a-form-item label="No. UM PP">
          <a-select
            :disabled="active || mode === 'Edit'"
            showSearch
            placeholder="Select No. UM"
            @change="handleNo"
            v-decorator="[
              'no_um',
              { rules: [{ required: true }], initialValue: initialData.no_um },
            ]"
          >
            <a-select-option v-for="item in listNoUMPP" :key="item.no_um">{{
              item.no_um
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Report Date">
          <a-date-picker
            placeholder="Select Date"
            :disabled="true"
            :format="getDefaultDateFormat"
            v-decorator="[
              'tanggal_pelaporan',
              {
                rules: [{ required: true }],
                initialValue: moment(initialData.tanggal_pelaporan),
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="Category">
          <a-radio-group
            buttonStyle="solid"
            v-decorator="['isparsial', {rules: [{required: true,message: 'Category is required!'}], initialValue: initialData.isparsial}]"
          >
            <a-radio-button value="1"> Parsial </a-radio-button>
            <a-radio-button value="0"> Final </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <div style="display:none">
<!--        <a-form-item label="Vice President Finance Approval">-->
<!--          <a-input-->
<!--            disabled-->
<!--            v-decorator="[-->
<!--              'bod',-->
<!--              { rules: [{ required: true }], initialValue: initialData.bod },-->
<!--            ]"-->
<!--          ></a-input>-->
<!--        </a-form-item>-->
        </div>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";

export default {
  name: "informasi",
  props: {
    data: {},
    others: {},
    mode: String,
    type: String,
    active: false,
    limitasi: Number,
  },
  data() {
    return {
      listNoUMPP: [],
      pageLoading: true,
      idUm: "",
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    if (this.mode === "Create" && !this.active) {
      this.listNoUMPP = [];
      this.fetchUmPP();
    } else {
      this.pageLoading = false;
    }
  },
  computed: {
    ...mapGetters(["getScreen", "getAuth", "getDefaultDateFormat"]),
    initialData() {
      if (this.data === undefined || this.data.length <= 0) {
        return {
          no_um: [],
          tanggal_pelaporan: moment().format(),
          bod: "",
          peruntukan: "",
          isparsial: "1",
          catatan: "",
        };
      } else {
        let peruntukan = "";
        if (this.mode === "Create") {
          peruntukan = this.data.peruntukan;
        } else {
          peruntukan = this.others.peruntukan;
        }
        return {
          no_um: this.data.no_um,
          tanggal_pelaporan: this.data.tanggal_pelaporan,
          bod: this.data.bod,
          peruntukan: peruntukan,
          isparsial: this.data.isparsial,
          catatan: this.data.catatan
        };
      }
    },
  },
  methods: {
    moment,
    fetchUmPP() {
      axios({
        method: "get",
        url: this.$serviceUrl + "lap_um_pp/no_umpp",
        params: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.listNoUMPP = response.data.no_umpd;
          this.pageLoading = false;
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response.data);
          if (err.response.status === 404) {
            if (
              this.mode === "Create" &&
              responses.message === "User Tidak Memiliki No UM PP"
            ) {
              this.displayMessageValue("error-notif-umpp", responses.message);
              this.pageLoading = false;
              this.loading = false;
              this.$router.go(-1);
            } else {
              this.displayMessage("404");
              this.pageLoading = false;
              this.loading = false;
            }
          }
        });
    },
    handleNo(e) {
      let data = {};
      data = this.listNoUMPP.filter(
        (obj) => obj.no_um.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );

      this.initialData.bod = data[0].bod + " - " + data[0].nama_bod;
      this.initialData.peruntukan = data[0].peruntukan;
      this.form.setFieldsValue({
        bod: data[0].bod + " - " + data[0].nama_bod,
      });
      this.idUm = data[0].id_um;
    },
    async handleRef() {
      let limitation = 0;
      await axios({
        method: "get",
        url: this.$serviceUrl + "main/limit_laporan_um",
        params: {
          id_um: this.mode == "Edit" ? this.data.id_um : this.idUm,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          limitation = response.data.limit;
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response.data);
          console.log(responses);
          this.displayMessageValue("error", responses);
        });

      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        let data = {};
        data = this.listNoUMPP.filter(
          (obj) => obj.no_um.indexOf(values.no_um) >= 0
        );

        const informasi = {
          tanggal_pelaporan: values.tanggal_pelaporan,
          no_um: values.no_um,
          bod: values.bod || "",
          peruntukan: this.initialData.peruntukan || "",
          id_um: data.length>0 ? data[0].id_um : this.data.id_um,
          limit: limitation,
          isparsial: values.isparsial,
          catatan: this.initialData.catatan
        };

        Event.$emit("lapUmpp", informasi);
      });
    },
    beforeRouteEnter(to, from, next) {
      this.fetchUmPP((err, post) => {
        next();
      });
    },
    clearForm() {
      this.form.resetFields();
    },
  },
};
</script>

<style>
</style>